import React, { useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import LoadingIcon from "mdi-react/LoadingIcon";
import { useTranslation } from "react-i18next";
import { useHistory, withRouter, Link } from "react-router-dom";
import { AvForm, AvField } from "availity-reactstrap-validation";

import { NavigateToPathWithGo } from "../../../../system";
import { configurationsConstants } from "../../../../constants";
import { loginConstants } from "../../../../constants/login.constants";
import * as modalConstants from "../../../../constants/modal.constants";
import { assetsConstants } from "../../../../constants/assets.constants";
import { shutterbActions } from "../../../../redux/actions";
import CheckBox from "../../../../shared/components/Fields/CheckBox";
import InputField from "../../../../shared/components/Fields/InputField";
import SideImage from "../../../../shared/components/SideImage/SideImage";

const ShutterbLogin = (props) => {
  const { t } = useTranslation("common");

  const history = useHistory();

  const [shouldRemember, setShouldRemember] = useState(false);

  const loginSpinner = useMemo(
    () =>
      props.spinnerActions.findIndex((f) => f === loginConstants.USER_LOGIN),
    [props.spinnerActions]
  );

  // when user clicks on Login button
  const handleSubmit = (event, values) => {
    props.onShutterbLoginClick({ ...values });
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  // navigate to Shutterb Dasboard if authenticated
  useEffect(() => {
    if (props.isShutterbAuthenticated) {
      NavigateToPathWithGo(
        history,
        "/Shutterbdashboard",
        "/Shutterbdashboard",
        2
      );
    }
    //eslint-disable-next-line
  }, [props.isShutterbAuthenticated]);

  return (
    <SideImage
      imageUrl={assetsConstants.SHUTTERB_LOGIN_IMAGE_URL}
      showBackButton={true}
    >
      <div className="login-form">
        <AvForm
          className="form_Display_Flex"
          onValidSubmit={handleSubmit}
          autoComplete="off"
        >
          <div className="pt-3 pt-sm-5">
            <div className="d-flex align-items-center position-relative my-md-2 my-4">
              <h2 className="text-center form-heading w-100 mb-0">
                shutterb login
              </h2>
            </div>
            <p className="p-0 pt-3 m-0 text-black-thin mb-3">
              welcome back! please fill in your email and password below to sign
              into your account.
            </p>
          </div>
          <div className="form__form-group">
            <div className="form__form-group-field">
              <div>
                <AvField
                  type="email"
                  name="userName"
                  placeholder="email"
                  className="form-control"
                  label={
                    <span className="form-label label-content-600">email</span>
                  }
                  maxLength={configurationsConstants.EMAIL_INPUT_LENGTH}
                  pattern="^[a-z,A-Z,0-9,!@#$%^&*_=+-].{3,}$"
                  validate={{
                    required: {
                      value: true,
                      errorMessage: t("this_field_is_required"),
                    },
                  }}
                />
              </div>
            </div>
          </div>
          <div className="form__form-group">
            <div className="form__form-group-field">
              <div>
                <InputField
                  type="password"
                  label={
                    <span className="form-label label-content-600">
                      password
                    </span>
                  }
                  name="password"
                  placeholder="password"
                  maxLength={configurationsConstants.PASSWORD_INPUT_LENGTH}
                  errorMessage={t("this_field_is_required")}
                  pattern="^[a-z,A-Z,0-9,!@#$%^&*_=+-].{3,}$"
                  validate={{
                    required: {
                      value: true,
                      errorMessage: t("this_field_is_required"),
                    },
                  }}
                />
              </div>
            </div>
          </div>
          <div className="form__form-group align-self-end d-flex justify-content-between align-items-center">
            <CheckBox
              containerClass={"teal-checkbox"}
              checked={shouldRemember}
              setChecked={setShouldRemember}
              labelText="remember me"
            />
            <p className="p-0 py-sm-1 py-md-1 m-0">
              <Link
                className="teal-text forgot-password-text"
                to={{
                  pathname: "/",
                  state: {
                    formSelect: modalConstants.FORGOT_PASSWORD_FORM,
                  },
                }}
              >
                forgot password?
              </Link>
            </p>
          </div>
          <div className="form__form-group mb-4">
            <div className="form__form-group-field">
              <div className="account__btns ml-0">
                {loginSpinner > -1 ? (
                  <div className=" account__btn text-center login_spinner">
                    <LoadingIcon fill="#70bbfd" style={{ width: "50px" }} />
                  </div>
                ) : (
                  <button
                    type="submit"
                    className="button-common button-fill btn-h36 w-100 mt-2"
                  >
                    {t("login")}
                  </button>
                )}
              </div>
            </div>
          </div>
        </AvForm>
        <div className="form__form-group align-self-center">
          <p className="p-0 m-0 mt-2 sign-up-shutterb">
            to become a shutterb
            <Link to="/be-a-shutterb" className="underline teal-text ml-2">
              sign up here
            </Link>
          </p>
        </div>
      </div>
    </SideImage>
  );
};

// Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  isShutterbAuthenticated: state.shutterbAuthentication.isShutterbAuthenticated,
  spinnerActions: state.system.spinnerActions,
});

// Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  onShutterbLoginClick: (data, setIsModalOpen) =>
    dispatch(shutterbActions.shutterbLogin(data, setIsModalOpen)),
});

// mapping action and store the function via props
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ShutterbLogin));
